import { Filter } from '@core/Entities/Search/SearchFilters/Filter.entity';

export function prepareFiltersArrayForEvent(filtersArray: Filter[] = []) {
  const filterObject: { [key: string]: string | string[] | undefined } = {};

  filtersArray.forEach(item => {
    const key = item.id;
    const value = item.value;
    filterObject[key] = value;
  });

  return filterObject;
}
